import { DietsListDietType } from '../api-response/plans-response-model';
import { Calorie } from '../generate-response-model';

export class GenerateModel {
  constructor(
    public dietType: DietsListDietType,
    public weight: number,
    public startDay: number,
    public startDays: any[],
    public goal: string,
    public calories: Calorie[],
    public difficulty: number,
    public calorie: string,
    public activityLevel: number,
    public specialTypeStartDate: number,
    public isVegeterian: boolean,
    public diseases: any[],
    public hatedfoods: any[],
    public fastingDays: any[]
  ) {}

  static fromJSON(json: GenerateJSON | string): GenerateModel {
    if (typeof json === 'string') {
      // if it's a string, parse it first
      return JSON.parse(json, GenerateModel.reviver);
    } else {
      // create an instance of the User class
      const generate = Object.create(GenerateModel.prototype);
      // copy all the fields from the json object
      return Object.assign(generate, json, {
        // convert fields that need converting
      });
    }
  }

  // reviver can be passed as the second parameter to JSON.parse
  // to automatically call User.fromJSON on the resulting value.
  static reviver(key: string, value: any): any {
    return key === '' ? GenerateModel.fromJSON(value) : value;
  }
}

interface GenerateJSON {
  dietType: DietsListDietType;
  weight: number;
  startDay: number;
  startDays: any[];
  goal: string;
  calories: Calorie[];
  difficulty: number;
  calorie: string;
  activityLevel: number;
  specialTypeStartDate: number;
  isVegeterian: boolean;
  diseases: any[];
  hatedfoods: any[];
  fastingDays: any[];
}
